export const RTCConfig = {
  iceServers: [
    {
      urls: [`stun:rtcweb.insahr.co.kr:3478`, `stun:stun.l.google.com:19302`],
    },
    {
      urls: [
        `turn:rtcweb.insahr.co.kr:3478?transport=udp`,
        `turn:rtcweb.insahr.co.kr:3478?transport=tcp`,
      ],
      username: `insahr`,
      credential: `WebRTC2022!`,
    },
    {
      urls: `turn:numb.viagenie.ca`,
      username: `webrtc@live.coms`,
      credential: `muazkh`,
    },
  ],
};
